import {Box} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    dialogPaper: {
        minWidth: "600px",
        maxWidth: "800px",
    },
    previewContainer: {
        backgroundColor: "#f5f5f5",
        padding: theme.spacing(3),
        borderRadius: "4px",
        marginBottom: theme.spacing(2),
    },
    emailPreview: {
        backgroundColor: "#ffffff",
        padding: "32px",
        borderRadius: "4px",
        fontFamily: "Arial, sans-serif",
        fontSize: "14px",
        lineHeight: "1.6",
        color: "#333333",
        border: "1px solid #e0e0e0",
    },
    emailHeader: {
        fontSize: "16px",
        fontWeight: "bold",
        marginBottom: "24px",
        color: "#1a1a1a",
    },
    emailSection: {
        marginBottom: "20px",
    },
    emailLabel: {
        fontWeight: "bold",
        color: "#555555",
        marginBottom: "4px",
    },
    emailValue: {
        color: "#333333",
        marginLeft: "8px",
    },
    emailFooter: {
        marginTop: "32px",
        paddingTop: "20px",
        borderTop: "1px solid #e0e0e0",
        fontSize: "13px",
        color: "#666666",
    },
}));

export function ContextEmail({
                                 notes,
                                 client_name = "CLIENTE",
                                 ddt_number = "****",
                                 ddt_date = "****",
                                 mission_number = "****",
                                 mission_date = "********",
                                 status = "-------",
                                 reason = "---------",
                                 signatory = "FIRMA UTENTE",
                             }: {
    notes: string,
    client_name?: string,
    ddt_number?: string,
    ddt_date?: string,
    mission_number?: string | number,
    mission_date?: string,
    status?: string,
    reason?: string,
    signatory?: string,
}) {
    const classes = useStyles();
    return (
        <Box className={classes.previewContainer}>
            <div className={classes.emailPreview}>
                <div className={classes.emailHeader}>
                    Gentile {client_name},
                </div>

                <div className={classes.emailSection}>
                    <div>
                        Le comunichiamo un aggiornamento relativo alla spedizione, rif. DDT n. <strong>{ddt_number}</strong> del <strong>{ddt_date}</strong>, missione n. <strong>{mission_number}</strong> del <strong>{mission_date}</strong>.
                    </div>
                </div>

                <div className={classes.emailSection}>
                    <div>
                        <span className={classes.emailLabel}>STATO:</span>
                        <span className={classes.emailValue}>{status}</span>
                    </div>
                </div>

                <div className={classes.emailSection}>
                    <div>
                        <span className={classes.emailLabel}>Motivo:</span>
                        <span className={classes.emailValue}>{reason}</span>
                    </div>
                </div>

                <div className={classes.emailSection}>
                    <div>
                        <span className={classes.emailLabel}>Note:</span>
                        <span className={classes.emailValue}>{notes || "-"}</span>
                    </div>
                </div>

                <div className={classes.emailSection}>
                    <div>
                        Attenzione: Questo indirizzo email è utilizzato esclusivamente per l'invio delle comunicazioni. Le risposte inviate a questa casella non riceveranno riscontro.
                    </div>
                </div>

                <div className={classes.emailFooter}>
                    <div>Cordiali saluti,</div>
                    <div style={{marginTop: "8px"}}>
                        <strong>{signatory}</strong>
                    </div>
                    <div style={{marginTop: "4px"}}>
                        <strong>Supersonica srl</strong>
                    </div>
                    <div style={{marginTop: "4px", fontSize: "12px"}}>
                        Eboli (SA) - Via prov. S. Chiarella, 1 - CAP 84025 - Tel. 08281995470
                    </div>
                </div>
            </div>
        </Box>
    )
}
